import {
  UserEngagementHistory,
  UserEngagementHistoryRequest,
} from '@backrs_ui/grow-ui/src/redux/userPortfolio/userEngagementHistory.api';

import { ENGAGEMENT_FIELDS } from './questions.config';
import { FormValue, FormValues } from './types';
import { convertDateToString, convertStringValue, convertDateFromString } from './utils';

export const convertValueForEngagementHistory = (
  column: string,
  values: FormValue[],
): string | number | boolean | number[] | undefined => {
  if (values.length === 0) return undefined;

  const value = values[0];

  switch (column) {
    case 'start_date':
    case 'end_date':
      return convertDateToString(value);

    default:
      return convertStringValue(value);
  }
};

export const buildEngagementHistoryFromFormValues = (
  formValues: FormValues,
): UserEngagementHistoryRequest => {
  const engagementHistoryData = ENGAGEMENT_FIELDS.reduce((acc, field) => {
    if (!field.engagementHistoryKey || !formValues[field.key]) return acc;

    const value = convertValueForEngagementHistory(
      field.engagementHistoryKey,
      formValues[field.key],
    );

    if (value !== undefined) {
      return {
        ...acc,
        [field.engagementHistoryKey]: value,
      };
    }

    return acc;
  }, {} as UserEngagementHistoryRequest);

  return engagementHistoryData;
};

export const prePopulateFormWithEngagementHistory = (
  existingEngagementHistory: UserEngagementHistory[],
  questionNumber: number,
): {
  engagementHistoryId: number;
  formValues: FormValues;
} | null => {
  const targetIndex = questionNumber - 1; // since the array is 0-indexed
  const targetEntry = existingEngagementHistory[targetIndex];

  if (!targetEntry) return null;

  return ENGAGEMENT_FIELDS.reduce(
    (acc, field) => {
      if (!field.engagementHistoryKey) return acc;

      const engagementHistoryValue = targetEntry[field.engagementHistoryKey];

      if (engagementHistoryValue === undefined || engagementHistoryValue === null) return acc;

      switch (field.engagementHistoryKey) {
        case 'organization_name':
        case 'city':
        case 'state':
        case 'role':
        case 'achievements':
          return {
            ...acc,
            formValues: {
              ...acc.formValues,
              [field.key]: [engagementHistoryValue as string],
            },
          };
        case 'start_date':
        case 'end_date':
          return {
            ...acc,
            formValues: {
              ...acc.formValues,
              [field.key]: [convertDateFromString(engagementHistoryValue as string)],
            },
          };
        default:
          return acc;
      }
    },
    {
      engagementHistoryId: targetEntry.id,
      formValues: {} as FormValues,
      selectedEngagementName: '',
    },
  );
};
